import { render, staticRenderFns } from "./detailFile1.vue?vue&type=template&id=44a6d2a9&scoped=true&"
import script from "./detailFile1.vue?vue&type=script&lang=js&"
export * from "./detailFile1.vue?vue&type=script&lang=js&"
import style0 from "./detailFile1.vue?vue&type=style&index=0&id=44a6d2a9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a6d2a9",
  null
  
)

export default component.exports